import config from "config";
import localStorageService from "services/sub-services/storage-service/local-storage.service";

function getOperations(key: string) {
  return {
    get: () => localStorageService.getItem(key),
    store: (token: string) => localStorageService.setItem(key, token),
    remove: () => localStorageService.removeItem(key),
  };
}

const accessTokenOperations = getOperations(config.accessTokenKey);
const refreshTokenOperations = getOperations(config.refreshTokenKey);

export { accessTokenOperations, refreshTokenOperations };
